/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useSortInfo = _interopRequireDefault(require("./useSortInfo"));
var _sorty = _interopRequireDefault(require("../../packages/sorty"));
var _default = {
  name: 'sortable-columns',
  hook: _useSortInfo.default,
  defaultProps: function defaultProps() {
    return {
      sorty: _sorty.default,
      sortable: true
    };
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/plugins/sortable-columns/index.js
// module id = 789
// module chunks = 0